import { useContext, useEffect } from "react";
import { useForm } from "react-hook-form";
import {
  FormGroup,
  Modal,
  ModalBody,
  Form,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Badge,
} from "reactstrap";
import { yupResolver } from "@hookform/resolvers/yup";
import { useSelector } from "react-redux";

import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import Button from "../../../components/Button/Button";
import Icon from "../../../components/Icon/Icon";
import ErrorMessage from "../../../helpers/ErrorMessage/ErrorMessage";
import PaginationComponent from "../../../components/Pagination/Pagination";
import TableFilter from "../../../components/TableFilter/TableFilter";
import PageHeader from "../../../components/PageHeader/PageHeader";
import SearchTable from "../../../components/SearchTable/SearchTable";
import EllipsisListItem from "../../../components/EllipsisListItem/EllipsisListItem";
import AvatarCropper from "../../../components/AvatarCropper/AvatarCropper";
import ProductImage from "../../../helpers/ProductImage/ProductImage";
import { Block } from "../../../components/Block/Block";
import {
  DataTable,
  DataTableBody,
  DataTableHead,
  DataTableItem,
  DataTableRow,
} from "../../../components/DataTable/DataTable";
import { Col, Row } from "../../../components/Grid/Grid";
import { areYouSureMessage } from "../../../utils/toastMessage/toastMessage";
import { categoryReceptionContext } from "../../../context/ReceptionContext/CategoryReceptionContext/CategoryReceptionContext";
import { createCategoryValidation } from "../../../utils/validation/validation";
import { convertDate } from "../../../utils";

const CategoriesReception = () => {
  const loader = useSelector((state) => state.loader);

  const {
    categories,
    id,
    filter,
    setFilter,
    sort,
    setSort,
    start,
    setStart,
    end,
    setEnd,
    pageCount,
    itemsCount,
    setItemsCount,
    pageNumber,
    setPageNumber,
    isShowModal,
    handleShowModal,
    handleHideModal,
    handleGetCategories,
    handleCreateCategory,
    handleEditCategory,
    handleDeleteCategory,
    handleChangeCategoryActive,
    handleUploadFile,
  } = useContext(categoryReceptionContext);

  useEffect(() => {
    handleGetCategories();
  }, [start, end, pageNumber, itemsCount, sort]);

  // Validation
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(createCategoryValidation),
  });

  return (
    <>
      <SiteTitle title="دسته بندی ها" />

      <PageHeader title="دسته بندی ها" />

      <TableFilter
        setItemsCount={setItemsCount}
        itemsCount={itemsCount}
        setSort={setSort}
        sort={sort}
        setStart={setStart}
        start={start}
        setEnd={setEnd}
        end={end}
      />

      <Block>
        <DataTable className="card-stretch">
          <SearchTable
            firstItem={
              <Button
                color="primary"
                className="btn-icon"
                onClick={() => {
                  handleShowModal();
                  reset();
                }}
              >
                <Icon name="plus" />
              </Button>
            }
            filterPlaceholder="عنوان و ..."
            filter={filter}
            setFilter={setFilter}
            onSearch={handleGetCategories}
          />
          <DataTableBody>
            <DataTableHead>
              <DataTableRow>
                <span className="sub-text">#</span>
              </DataTableRow>
              <DataTableRow>
                <span className="sub-text">تصویر</span>
              </DataTableRow>
              <DataTableRow>
                <span className="sub-text">عنوان</span>
              </DataTableRow>
              <DataTableRow size="lg">
                <span className="sub-text">تاریخ ایجاد</span>
              </DataTableRow>
              <DataTableRow size="md">
                <span className="sub-text">وضعیت</span>
              </DataTableRow>
              <DataTableRow />
            </DataTableHead>
            {/*Head*/}
            {categories.length > 0
              ? categories.map((item, index) => {
                  return (
                    <DataTableItem key={item._id}>
                      <DataTableRow>
                        <span>{index + 1}</span>
                      </DataTableRow>
                      <DataTableRow>
                        <span className="tb-category text-center">
                          <ProductImage picture={item.picture} />
                        </span>
                      </DataTableRow>
                      <DataTableRow>
                        <EllipsisListItem title={item.title} />
                      </DataTableRow>
                      <DataTableRow size="lg">
                        <span>
                          {convertDate(item.createdAt, "YYYY/MM/DD - HH:mm")}
                        </span>
                      </DataTableRow>
                      <DataTableRow size="md">
                        <Badge
                          color={item.isActive ? "success" : "danger"}
                          className="badge-dot has-bg"
                        >
                          {item.isActive ? "فعال" : "غیرفعال"}
                        </Badge>
                      </DataTableRow>

                      <DataTableRow className="nk-tb-col-tools">
                        <ul className="nk-tb-actions gx-1">
                          <li>
                            <UncontrolledDropdown>
                              <DropdownToggle
                                tag="a"
                                className="dropdown-toggle btn btn-icon btn-trigger"
                              >
                                <Icon name="more-h" />
                              </DropdownToggle>
                              <DropdownMenu
                                left
                                className="dropdown_max_height"
                              >
                                <ul className="link-list-opt no-bdr text-right">
                                  <li
                                    onClick={() => {
                                      reset();
                                      handleShowModal(item, setValue);
                                    }}
                                  >
                                    <DropdownItem tag="a" type="button">
                                      <Icon name="edit-alt-fill" />
                                      <span>ویرایش</span>
                                    </DropdownItem>
                                  </li>
                                  <li className="divider" />
                                  <li
                                    onClick={() =>
                                      areYouSureMessage(
                                        () =>
                                          handleChangeCategoryActive(item._id),
                                        `آیا از ${
                                          !item.isActive ? "فعال" : "غیرفعال"
                                        } کردن دسته بندی ${item.title} مطمئنید؟`
                                      )
                                    }
                                  >
                                    <DropdownItem
                                      tag="a"
                                      type="button"
                                      className={`text-${
                                        !item.isActive ? "success" : "danger"
                                      }`}
                                    >
                                      <Icon
                                        name={
                                          !item.isActive ? "check" : "cross"
                                        }
                                      />
                                      <span>
                                        {!item.isActive ? "فعال" : "غیرفعال"}
                                      </span>
                                    </DropdownItem>
                                  </li>
                                  <li
                                    onClick={() =>
                                      areYouSureMessage(
                                        () => handleDeleteCategory(item._id),
                                        `آیا از حذف دسته بندی ${item.title} مطمئنید؟`
                                      )
                                    }
                                  >
                                    <DropdownItem
                                      tag="a"
                                      type="button"
                                      className="text-danger"
                                    >
                                      <Icon name="trash-fill" />
                                      <span>حذف</span>
                                    </DropdownItem>
                                  </li>
                                </ul>
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          </li>
                        </ul>
                      </DataTableRow>
                    </DataTableItem>
                  );
                })
              : null}
          </DataTableBody>
          <div className="card-inner">
            {categories.length > 0 ? (
              <PaginationComponent
                pageCount={pageCount}
                currentPage={pageNumber}
                setPageNumber={setPageNumber}
              />
            ) : (
              <div className="text-center">
                <span className="text-silent">داده ای برای نمایش یافت نشد</span>
              </div>
            )}
          </div>
        </DataTable>
      </Block>

      <Modal
        isOpen={isShowModal}
        toggle={() => handleHideModal()}
        className="modal-dialog-centered"
        size="md"
      >
        <ModalBody>
          <span
            type="button"
            onClick={() => handleHideModal()}
            className="close"
          >
            <Icon name="cross-sm" />
          </span>
          <div className="p-2">
            <h5 className="title">
              {id ? "ویرایش دسته بندی" : "افزودن دسته بندی جدید"}
            </h5>
            <br />
            <Form
              autoComplete="off"
              className="is-alter"
              onSubmit={handleSubmit(
                id ? handleEditCategory : handleCreateCategory
              )}
            >
              <AvatarCropper
                onRemove={() => setValue("picture", "")}
                value={watch("picture")}
                onChange={(file) =>
                  handleUploadFile(file, (e) => setValue("picture", e))
                }
              />
              <Row className="gy-4">
                <Col size="12">
                  <FormGroup>
                    <label className="form-label" htmlFor="title">
                      عنوان
                    </label>
                    <div className="form-control-wrap">
                      <input
                        type="text"
                        placeholder="عنوان دسته بندی را وارد نمایید"
                        className="form-control-lg form-control"
                        autoFocus
                        {...register("title")}
                      />
                      <ErrorMessage message={errors.title?.message} />
                    </div>
                  </FormGroup>
                </Col>
                <Col size="12">
                  <FormGroup>
                    <label className="form-label" htmlFor="description">
                      توضیحات
                    </label>
                    <div className="form-control-wrap">
                      <textarea
                        type="text"
                        placeholder="توضیحات دسته بندی را وارد نمایید"
                        className="form-control-lg form-control"
                        {...register("description")}
                      />
                      <ErrorMessage message={errors.description?.message} />
                    </div>
                  </FormGroup>
                </Col>
                <Col size="12">
                  <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                    <li>
                      <Button
                        color="primary"
                        size="lg"
                        type="submit"
                        loading={loader}
                      >
                        {id ? "ویرایش" : "افزودن"} دسته بندی
                      </Button>
                    </li>
                    <li>
                      <button
                        type="button"
                        onClick={() => handleHideModal()}
                        className="link link-light"
                      >
                        انصراف
                      </button>
                    </li>
                  </ul>
                </Col>
              </Row>
            </Form>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default CategoriesReception;
